import axios from 'axios';
import api from './api';

const CommentsService = {
  // Get all comments for a post
  getCommentsByPostId: (postId, params={}) => {
    return api.get(`/comments`, { params: { post_id: postId, ...params } });
  },

  // Create a new comment on a post
  createComment: (commentData) => {
    return api.post(`/comments/create`, commentData);
  },

  // Delete a comment
  deleteComment: (commentId, postId) => {
    return api.post(`/comments/${commentId}/delete`, { post_id: postId });
  },

  // Update a comment
  updateComment: (commentId, commentData) => {
    return api.post(`/comments/${commentId}/edit`, commentData);
  },

  // Get comment replies
  getCommentReplies: (commentId, params = {}) => {
    return api.get(`/comments/${commentId}/replies`, { params });
  },

  // Create a reply to a comment
  createReply: (commentId, replyData) => {
    return api.post(`/comments/${commentId}/replies/create`, replyData);
  },

  // Like or unlike a comment
  toggleCommentLike: (commentId, isLiked) => {
    return api.post(`/comments/${commentId}/like`, { liked: isLiked });
  },
  
  
  // Report a comment
  reportComment: (commentId, reportData) => {
    return api.post(`/report`, { reason: reportData, comment_id: commentId });
  }
};

export default CommentsService;
